import React, { Component } from "react";
import _ from "lodash"; 
import "./ficheCss.scss";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import {
  getArticleList,
  getArticleHeader,
} from "../../redux/actions/ArticleActions";
import "../../App.css";
import Typography from "@material-ui/core/Typography";
//import { SelectFiche} from "../../redux/actions/GetficheSTK";
import{SelectAllEcheanceFRS}from"../../redux/actions/EcheanceFRS";
import AddingArticleModal from "../gestion-des-articles/AddingArticleModal";
import GetArticleByIdModal from "../gestion-des-articles/GetArticleByIdModal";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import moment from 'moment';
import {
  TextField,
  Button,
  Breadcrumbs,
  InputBase,
  FormLabel,
  Paper,
  TableSortLabel,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
} from "@material-ui/core";
import { Divider, Fab, IconButton, Snackbar } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { emphasize, withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import AddIcon from "@material-ui/icons/Add";
import HomeIcon from "@material-ui/icons/Home";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import "../gestion-des-articles/Responsiveart.css";
import DateRangeIcon from "@material-ui/icons/DateRange";
//   import RelevecliDetaill from "./RelevecliDetaill";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
 
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
//import * as XLSX from 'xlsx';
import EditIcon from "@material-ui/icons/Edit";
import PrintIcon from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import translate from "../../i18n/translate";
const actions = [
  // { icon: <MailOutlineIcon />, name: "Mail" },
  // { icon: <EditIcon />, name: "Modifier" },
  // { icon: <DeleteOutlineIcon />, name: "Supprimer" },
  // { icon: <ListAltIcon />, name: "Relevé" },
];

const DATE_OPTIONS = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};


var curr = new Date();
curr.setDate(curr.getDate());
var date = curr.toISOString().substr(0, 10);
var event = new Date();
event.setDate(1);
event.setMonth(0);

var date2 = event.toISOString().substr(0, 10);


class Echeancefrs extends Component {
  constructor(props) {
    super(props);
    const token = localStorage.getItem("token");

    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }
    this.state = {
      data: [],
      openReleveClientModal: false,
      modal: false,
      addModalShow1: false,
      GetByIdModalShow: false,
      getArticleByIdModalShow: false,
      defaultdate: date,
      d1:date2,
      firstdate: date2,
      seconddate: date,
      loggedIn,
      rechs: [],
      icon: false,
      rechercheclicked: false,
      order: "asc",
      orderBy: "",
      showrechbydate: false,
      showrechbydatecodeart: false,
      rechdats: [],
      rechdatscodeart: [],
   
      addModalShow: false,
      GetBSByIdModalShow: false,
      loggedIn,
   
      icon: false,
     
      tabtab: [],

      GMM: "",
      fichGMM:[],
      showrechbydatecodeartGMM: false,
      rechdatsGMM: [],
      rechdatscodeartGMM: [], 
      rechsGMM: [],
       rechercheclickedGMM: false,
      
       frsdeb:'+',
     frsdeb:'+',
     datdeb:'01/01/2000',
       datfin:'01/01/2026',
      ModReg:'%',
      Banque:'%',
      Categ:'%',
      egion:'%',
       Rep:'%',
      Situation:'%',
       CodCCB:'%',
      NumCais:'%',
      
      
      gilad: true,
     
      
    };
  }

  toggle = () => this.setState({ modal: !this.state.modal });
  handleOpen = () => {
    this.setState({ open: true });
    
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  componentDidMount() {
    this.props.getArticleHeader();
 
   
   
    this.props.SelectAllEcheanceFRS(
    
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );
   
  
   
    document.title = "Fiche Article";
    // this.setState({ rechs: this.props.articles.articles });
 
    
  } 
 

  firstrechdatHandler = (event) => {
    this.setState({rechdats: []});
    this.setState({ firstdate: event.target.value });
    const wildcard = encodeURIComponent("%");
    const empty = '+';
    fetch(
     `https://www.24-crm.tn/webservice/api/Echeancefrs?date&frsdeb=${empty}&frsfin=${empty}&datdeb=${event.target.value}&datfin=${this.state.seconddate}&ModReg=${wildcard}&Banque=${wildcard}&Categ=${wildcard}&Region=${wildcard}&Situation=${wildcard}&CodCCB=${wildcard}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
      )
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          rechdats: data,
          showrechbydate: true,
          rechercheclicked: false,
        })
      );
  };

  secondrechdatHandler = (event) => {
    // this.setState({rechdats: []});
     this.setState({ seconddate: event.target.value });

   
    this.setState({rechdats: []});
    //this.setState({ firstdate: event.target.value });
    const wildcard = encodeURIComponent("%");
    const empty = '+';
    fetch(
    `https://www.24-crm.tn/webservice/api/Echeancefrs?date&frsdeb=${empty}&frsfin=${empty}&datdeb=${this.state.firstdate}&datfin=${event.target.value}&ModReg=${wildcard}&Banque=${wildcard}&Categ=${wildcard}&Region=${wildcard}&Situation=${wildcard}&CodCCB=${wildcard}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    
      )
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          rechdats: data,
          showrechbydate: true,
          rechercheclicked: false,
        })
      );
  };
 

  rechercheHandler = (event) => {


this.setState({rechs: []});
const wildcard = encodeURIComponent("%");
    const empty = '+';
    const today = new Date();
    today.setFullYear(today.getFullYear() + 20);
    const datePlus2Ans = today.toISOString().slice(0, 10);
fetch(
   `https://www.24-crm.tn/webservice/api/Echeancefrs?iddd&coddeb=${event.target.value}&codfin=${event.target.value}&datdeb=01/01/2000&datfin=${datePlus2Ans}&ModReg=${wildcard}&Banque=${wildcard}&Categ=${wildcard}&Region=${wildcard}&Situation=${wildcard}&CodCCB=${wildcard}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
  .then((response) => response.json())
  .then((data) => this.setState({ rechs: data, 
    rechercheclicked: true,
 
   }));
  };



  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };
  handleCheckboxChangeA = (event) => {
    const isChecked = event.target.checked;
    const valeur = isChecked ? 1 : 0; // 1 si coché, 0 sinon
  
    // Mettez à jour l'état
    this.setState({ EscompterA: valeur });
   
    // Utilisez la valeur (0 ou 1) comme vous le souhaitez
    console.log("Valeur de la case à cocher : ", valeur);
  }
  remiseChange = (event) => {
    this.setState({
      stkfin1: event.target.value,
      totalstfin:
      this.state.QteEntr + this.state.QteRet - this.state.QteRet
          
 
    });
       console.log("totalstfin",this.props.totalstfin)
  };

  openReleveClient = () => {
    this.setState({ openReleveClientModal: true });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
    if(this.state.GMM==false){
      this.state.gilad
    ? this.setState({ showrechbydatecodeart: false })
    ? this.setState({ rechercheclicked: false }) 
    :this.setState({showrechbydatecodeart:false}):this.setState({showrechbydatecodeart:false});
 
  }else{ 
     this.state.gilad
      ? this.setState({ showrechbydatecodeart: false })
      ? this.setState({ rechercheclickedGMM: false }) 
      :this.setState({showrechbydatecodeart:false}):this.setState({showrechbydatecodeart:false});
}
       
   
  
    
  };
 


  



  totalGeneralsCreadits = () => {
    let totalcredit = 0;
 
    if(this.state.rechercheclicked){
      this.state.rechs.forEach((article) => {
       
        totalcredit+= parseFloat(Number(article.credit));
    })
  }else if(this.state.showrechbydate){
    this.state.rechdats.forEach((article) => {
     
      totalcredit+= parseFloat(Number(article.credit));
  })
}else{
    this.props.AllReleverClient.AllReleverClient.forEach((article) => {
        totalcredit += parseFloat(Number(article.credit));
      })
  }
      return totalcredit.toFixed(3); // arrondi à 4 chiffres après la virgule

  };

  totalGeneralsDebits = () => {
    let totalcredit = 0;
 
    if(this.state.rechercheclicked){
      this.state.rechs.forEach((article) => {
        totalcredit += parseFloat(Number(article.debit));
      })
      }else
      if(this.state.showrechbydate){
        this.state.rechdats.forEach((article) => {
          totalcredit += parseFloat(Number(article.debit));
        })
        }else{ 
    this.props.AllReleverClient.AllReleverClient.forEach((article) => {
        totalcredit += parseFloat(Number(article.debit));
      })
    }
      return totalcredit.toFixed(3); // arrondi à 4 chiffres après la virgule

  };


  render() {
   
   //  console.log("fichesGMM", this.state.AllReleverClient)
    const classes = {
      visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1,
      },
    };
    const rowCount = stableSort(
      this.props.AllReleverClient.AllReleverClient,
      getComparator(this.state.order, this.state.orderBy)
    ).length;
  // console.log("raisoc 1", this.props.AllReleverClient.AllReleverClient.map((D,i) => (D.raisoc[0])));

  //   console.log(
  //     "raisoc 2",
  //     [...new Set(this.props.AllReleverClient.AllReleverClient.map((D) => D.raisoc))]
  //   );
    console.log(`Nombre de lignes affichées: ${rowCount}`);
    let ReleveClientModalClose = () => this.setState({ openReleveClientModal: false });
   //   let addModalClose1 = () => this.setState({ addModalShow1: false });
    let GetByIdModalClose = () => this.setState({ GetByIdModalShow: false });
    const {
      codcli,
      raisoc,
      datfac,
      libelle,
      SIT,
      MR,
      CHQ,
      debit,
      credit,
      Solde,
    } = this.state;
   const { darck } = this.props;


const groupedDatALL = _.groupBy(this.props.AllEchFRS.AllEchFRS, "raisoc");
const groupedDatarechs = _.groupBy(this.state.rechs, "raisoc");
const groupedDatarechdats = _.groupBy(this.state.rechdats, "raisoc");
// 


    return (
      <div>
        <Breadcrumbs aria-label="breadcrumb" fontSize="small">
          <Link to={"/"}>
            <StyledBreadcrumb
              component="a"
              label="Finance"
              icon={
                <HomeIcon
                  fontSize="small"
                  style={{ color: `${darck ? "" : "#fff"}` }}
                />
              }
              style={{
                color: `${darck ? "" : "#fff"}`,
                backgroundColor: `${darck ? "" : "#172431"}`,
                border: "2px solid #fff",
              }}
            />
          </Link>

          <StyledBreadcrumb
            component="a"
            color="Primary"
            style={{
              color: `${darck ? "rgb(63, 81, 181)" : "#fff"}`,
              backgroundColor: `${darck ? "" : "#172431"}`,
              border: `${darck ? "" : "2px solid #fff"}`,
            }}
            
            label="Echeanciers Fournisseurs"
            icon={<MenuBookIcon fontSize="small" />}
          />
              
        </Breadcrumbs>
        <main className="gestion-des-articles">
        
          <br />
          <div>
            <Paper
             
              elevation={2}
              style={{
                backgroundColor: `${darck ? "" : "#172431"}`,
                border: `${darck ? "" : "2px solid #fff"}`,
              }}
            >
              <Row style={{display : "flex" , flexWrap: "nowrap" , marginTop:"2px"}}>
              <Col sm={10}>
               
                &nbsp;&nbsp;
                <DateRangeIcon
                  className="search-icon"
                  color={this.state.isSearchDate ? "primary" : "inherit"}
                  onClick={() => this.setState({ isSearchDate: true })}
                  style={{ color: `${darck ? "" : "#fff"}` }}
                /> 
                <SearchIcon
                  className="search-icon"
                  color={this.state.isSearchDate ? "inherit" : "primary"}
                  onClick={() => this.setState({ isSearchDate: false })}
                  style={{ color: `${darck ? "" : "#fff"}` }}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                {this.state.isSearchDate ? (
                  <>
                   
                    <FormLabel style={{ color: `${darck ? "" : "#fff"}` }}>
                      Date début
                    </FormLabel>
                    &nbsp;&nbsp;
                    <InputBase
                      type="date"
                      // fullWidth={true}
                      placeholder="date"
                      onClick={this.toggle}
                      onChange={this.firstrechdatHandler}
                      value={this.state.firstdate}
                      defaultValue={this.state.d1}
                      style={{ color: `${darck ? "" : "#fff"}` }}
                    />{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <FormLabel style={{ color: `${darck ? "" : "#fff"}` }}>
                      Date Fin
                    </FormLabel>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <InputBase
                      type="date"
                      // fullWidth={true}
                      placeholder="date"
                      defaultValue={this.state.defaultdate}
                      onChange={this.secondrechdatHandler}
                      value={this.state.seconddate}
                      style={{ color: `${darck ? "" : "#fff"}` }}
                    />
                  
                  </>
                ) : (
                 
                 <> 
          {this.state.GMM ? (<>  
                      <InputBase
                 margin="dense"
                 // fullWidth={true}
                 placeholder="Rechercher par code art "
                 defaultValue={this.state.codart2}
                 onChange={this.rechercheHandler}
                 value={this.state.codart2}
                 onClick={this.toggle}
                 style={{ color: `${darck ? "" : "#fff"}` }}
               />
                     <SearchIcon
                  className="search-icon"
                  color={this.state.isSearchDate ? "inherit" : "primary"}
                  onClick={() => this.setState({ isSearchDate: false })}
                  style={{ color: `${darck ? "" : "#fff"}` }}
                />
                

                <InputBase
                   margin="dense"
                    //fullWidth={true}
                   placeholder="Rechercher par Mg "
                   onChange={this.rechercheHandlerGMM}
                   onClick={this.toggle}
                   style={{ color: `${darck ? "" : "#fff"}` }}
                 /> 
                </>):(<>  
                 <InputBase
                margin="dense"
                // fullWidth={true}
                placeholder="Rechercher "
                onChange={this.rechercheHandler}
                onClick={this.toggle}
                style={{ color: `${darck ? "" : "#fff"}` }}
              /> &nbsp;&nbsp; &nbsp;&nbsp;
              
                  </>)}
                </>
                )}
              </Col>
              
                {this.props.Auth.fct == "100" ? (
                  <Col sm={2} style={{ display: "flex", justifyContent: "end" }} className="buttart">
                  
                  </Col>
                ) : null}{" "}
              </Row>
            </Paper>
          
           
          </div>
          <br />

          {this.state.rechercheclicked ?(
                <div className="tabga">
             <table striped>
                  <EnhancedTableHead
                    classes={classes}
                    order={this.state.order}
                    orderBy={this.state.orderBy}
                    onRequestSort={this.handleRequestSort}
                    darck={darck}
                  />
                  <tbody style={{ maxHeight: "60vh" }}>
                  {stableSort(
                                   this.state.rechs,
                                   getComparator(this.state.order, this.state.orderBy)
                                 ).map((article) => (
                       <tr key={article} style={{ cursor: "pointer" }}>
                    
                      {/* Date échéance */}
                      <td style={{ color: darck ? "#182532" : "#fff" }}>
                        {article.datech
                          ? moment(article.datech).format("DD/MM/YYYY")
                          : "--"}
                      </td>
            
                      {/* Client */}
                      <td>
                        <span
                          style={{
                            color: "#8f2d56",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          {article.codfrs} {article.raisoc}
                        </span>
                      </td>
            
                      {/* Libellé */}
                      <td style={{ color: darck ? "#182532" : "#fff" }}>
                        {article.libelle || "--"}
                      </td>
            
                      {/* Mode règlement */}
                      <td style={{ color: darck ? "#0D47A1" : "#fff" }}>
                        {article.modreg || "--"}
                      </td>
            
                      {/* N° chèque */}
                      <td style={{ color: darck ? "#182532" : "#fff" }}>
                        {article.numchq || "--"}
                      </td>
            
                    
                      {/* Date règlement */}
                      <td style={{ color: darck ? "#182532" : "#fff" }}>
                        {article.datreg
                          ? moment(article.datreg).format("DD/MM/YYYY")
                          : "--"}
                      </td>
            
                      {/* Montant */}
                      <td style={{ color: "#155757", fontWeight: "bold" }}>
                        {Number(article.monreg || 0).toFixed(3)}
                      </td>
            
                    
                    </tr>
                    ))}
                  </tbody>
                </table>
              {/* TOTAL */}
            <Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.state.rechs
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>
        
                                                
                <br />
                 
                           
                
                                         </div>
          ):  this.state.showrechbydate ? (
            <div className="tabga">
           
            <table striped>
              <EnhancedTableHead
                classes={classes}
                order={this.state.order}
                orderBy={this.state.orderBy}
                onRequestSort={this.handleRequestSort}
                darck={darck}
              />
              <tbody style={{ maxHeight: "60vh" }}>
              {stableSort(
                               this.state.rechdats,
                               getComparator(this.state.order, this.state.orderBy)
                             ).map((article) => (
                                <tr key={article} style={{ cursor: "pointer" }}>
                    
                                {/* Date échéance */}
                                <td style={{ color: darck ? "#182532" : "#fff" }}>
                                  {article.datech
                                    ? moment(article.datech).format("DD/MM/YYYY")
                                    : "--"}
                                </td>
                      
                                {/* Client */}
                                <td>
                                  <span
                                    style={{
                                      color: "#8f2d56",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {article.codfrs} {article.raisoc}
                                  </span>
                                </td>
                      
                                {/* Libellé */}
                                <td style={{ color: darck ? "#182532" : "#fff" }}>
                                  {article.libelle || "--"}
                                </td>
                      
                                {/* Mode règlement */}
                                <td style={{ color: darck ? "#0D47A1" : "#fff" }}>
                                  {article.modreg || "--"}
                                </td>
                      
                                {/* N° chèque */}
                                <td style={{ color: darck ? "#182532" : "#fff" }}>
                                  {article.numchq || "--"}
                                </td>
                      
                              
                                {/* Date règlement */}
                                <td style={{ color: darck ? "#182532" : "#fff" }}>
                                  {article.datreg
                                    ? moment(article.datreg).format("DD/MM/YYYY")
                                    : "--"}
                                </td>
                      
                                {/* Montant */}
                                <td style={{ color: "#155757", fontWeight: "bold" }}>
                                  {Number(article.monreg || 0).toFixed(3)}
                                </td>
                      
                              
                              </tr>
                ))}
              </tbody>
            </table>
            
       
    
                                            
            <br />
             
              {/* TOTAL */}
              <Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.state.rechdats
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>           
            
                                     </div>
          ):(   
            <div className="tabga">
            <table striped>
              <EnhancedTableHead
                classes={classes}
                order={this.state.order}
                orderBy={this.state.orderBy}
                onRequestSort={this.handleRequestSort}
                darck={darck}
              />
          
              <tbody style={{ maxHeight: "60vh" }}>
                {stableSort(
                  this.props.AllEchFRS.AllEchFRS,
                  getComparator(this.state.order, this.state.orderBy)
                  
                ).map((article, index) => (
                    
                  <tr key={index} style={{ cursor: "pointer" }}>
                    
                    {/* Date échéance */}
                    <td style={{ color: darck ? "#182532" : "#fff" }}>
                      {article.datech
                        ? moment(article.datech).format("DD/MM/YYYY")
                        : "--"}
                    </td>
          
                    {/* Client */}
                    <td>
                      <span
                        style={{
                          color: "#8f2d56",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {article.codfrs} {article.raisoc}
                      </span>
                    </td>
          
                    {/* Libellé */}
                    <td style={{ color: darck ? "#182532" : "#fff" }}>
                      {article.libelle || "--"}
                    </td>
          
                    {/* Mode règlement */}
                    <td style={{ color: darck ? "#0D47A1" : "#fff" }}>
                      {article.modreg || "--"}
                    </td>
          
                    {/* N° chèque */}
                    <td style={{ color: darck ? "#182532" : "#fff" }}>
                      {article.numchq || "--"}
                    </td>
          
                  
                    {/* Date règlement */}
                    <td style={{ color: darck ? "#182532" : "#fff" }}>
                      {article.datreg
                        ? moment(article.datreg).format("DD/MM/YYYY")
                        : "--"}
                    </td>
          
                    {/* Montant */}
                    <td style={{ color: "#155757", fontWeight: "bold" }}>
                      {Number(article.monreg || 0).toFixed(3)}
                    </td>
          
                  
                  </tr>
                ))}
              </tbody>
            </table>
          
            {/* TOTAL */}
            <Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.props.AllEchFRS.AllEchFRS
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>
          
            <br />
          </div>
          
             )}

        
  {/* /////////////////////////////////////////////////////////// debut print etat ////////////////////////////////////////////////////////////// */}

           
  <Row>
              <Col sm={10}></Col>
              <Col sm={2}>
                <SpeedDial
                  style={{ position: "absolute", bottom: "5px", right: "30px" }}
                  ariaLabel="SpeedDial openIcon example"
                  hidden={this.state.hidden}
                  icon={<PrintIcon openIcon={<PrintIcon />} />}
                  onClose={this.handleClose}
                  onOpen={this.handleOpen}
                  open={this.state.open}
                  FabProps={{ size: "small" }}
                >
                  {actions.map((action) => (
                    <SpeedDialAction
                      key={action.name}
                      icon={action.icon}
                      tooltipTitle={action.name}
                      onClick={() => {
                        this.handleClose();
                        action.name === "Imprimer" && this.affiche();
                      
                      }}
                    />
                  ))}
                    {!this.state.open ? (
                    <ReactToPrint
                      trigger={() => (
                        <Fab
                          size="small"
                          style={{
                            backgroundColor: "white",
                            display: "none",
                          }}
                          aria-label="add"
                        >
                          <PrintIcon />
                        </Fab>
                      )}
                      content={() => this.componentRef}
                    />
                  ) : (
                    <ReactToPrint
                      trigger={() => (
                        <Fab
                          size="small"
                          style={{
                            backgroundColor: "white",
                            marginLeft: "7px",
                            marginTop: "7px",
                            color: "grey",
                          }}
                          aria-label="add"
                        >
                          <PrintIcon />
                        </Fab>
                      )}
                      content={() => this.componentRef}
                    />
                  )}
                </SpeedDial>
              
                   </Col>
            </Row>  
  <div style={{ display: "none" }}>
  <div
              ref={(el) => (this.componentRef = el)}
             style={{ margin: "40px  10px 20px 10px", height: "94%" }}
            >
  
        <img
          src={`data:image/png;base64,${this.props.InfoEntreprise[0].Photo} `}
        alt="Pas-Photo"
          style={{width: "250px",height: "auto",position: "absolute",top: "15px",right: "15px",}} 
        /> 
        
        
                    <h1 style={{ fontSize: "50px", fontWeight: "bolder" ,marginLeft: "25px"}}>
                       {/* Société {this.props.InfoEntreprise[0].coddos} */}
        {this.props.InfoEntreprise[0].lib}
                    </h1>
                    <p style={{ fontSize: "20px", marginTop: "-10px" ,marginLeft: "25px",}}>
                      {this.props.InfoEntreprise[0].spe}
                      <br />
                      Adresse : {this.props.InfoEntreprise[0].adr} <br />
                      Tél:{this.props.InfoEntreprise[0].tel1} / Gsm:{" "}
                      {this.props.InfoEntreprise[0].tel2} / Email:{" "}
                      {this.props.InfoEntreprise[0].email} <br />
                    Matricule Fiscal : {this.props.InfoEntreprise[0].codtva} <br />
                      RIB: {this.props.InfoEntreprise[0].rib}{" "}
                      {this.props.InfoEntreprise[0].matban}{" "}
                      {this.props.InfoEntreprise[0].agence}{" "}
                      {this.props.InfoEntreprise[0].ville}
                      <br />
                      {translate("Etabli par")}: {this.props.Auth.username}
                    </p>
                    {
                        this.state.rechercheclicked ? (  <>
                    <h5
                      style={{
                        marginLeft: "450px",
                        flexDirection: "column",
                        marginTop: "25px",
                        marginBottom: "-35px",
                        fontWeight: "bolder",
                      }}
                    >
                    
                <>Echeanciers Fournisseurs </>
                  
                    </h5>
                    <br/>
                   </>
                            
                        ) : this.state.showrechbydate ? (
                           <> <h5
                      style={{
                        marginLeft: "450px",
                        flexDirection: "column",
                        marginTop: "25px",
                        marginBottom: "-35px",
                        fontWeight: "bolder",
                      }}
                    >
                    
                <>Echeanciers Fournisseurs </>
                  
                    </h5>

                    <br/>
                    <h5
                    style={{
                        marginLeft: "390px",
                        flexDirection: "column",
                        marginTop: "25px",
                        marginBottom: "-35px",
                        fontWeight: "bolder",
                    }}
                    >

                        
                            de&nbsp;{moment(this.state.firstdate).format("DD/MM/YYYY")}
                            &nbsp;Au&nbsp;
                            {moment(this.state.seconddate).format("DD/MM/YYYY")}   </h5></>
                    
                        ) :(<h5
                            style={{
                              marginLeft: "450px",
                              flexDirection: "column",
                              marginTop: "25px",
                              marginBottom: "-35px",
                              fontWeight: "bolder",
                            }}
                          >
                          
                      <>Echeanciers Fournisseurs </>
                        
                          </h5>
                          
                          
                          
                          )
                        }

            <Col> <h6 style={{ marginLeft: "35px", marginTop: "40px" ,      marginBottom: "20px", }}> Edité le :{" "}  {new Date(this.state.defaultdate).toLocaleDateString(DATE_OPTIONS)} </h6>
            <h6
                      style={{
                        marginLeft: "35px",
                        flexDirection: "column",
                        marginTop: "25px",
                        marginBottom: "-35px",
                        fontWeight: "bolder",
                      }}
                    >
                   {this.state.rechercheclicked ?( <> Fournisseurs: {[...new Set(this.state.rechs.map(i => i.raisoc))].join(', ')}</>):(<> </>)}
                    </h6>
                      </Col>
                  
                    <div
                      style={{
                        marginLeft: "5px",
                        marginTop: "10px",
                        width: "99%",
                        minHeight: "540px",
                        padding: "20px 25px",
                      }}
                    >  
            
            

            {this.state.rechercheclicked ?(   
              <>
                   <table
            style={{
                textAlign: "center",
                borderStyle: "10px",
                width: "100%",
                marginTop: "25px",
            }}
            >
            <thead
                style={{
                textAlign: "center",
                paddingTop: "10px",
                paddingBottom: "30px",
                }}
            >
                <tr
                style={{
                    borderBottom: "1px solid grey",
                    border: "1px solid grey",
                    height: "50px",
                }}
                >
                <th style={{ width: "15%" }}>{translate("Date Echeance")}</th>
                <th style={{ width: "25%", border: "1px solid gray" }}>
                    {translate("Fournisseurs")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("Regelement")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("M.Reg")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("N° Pièce")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Date Reg")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Montant")}
                </th>
                </tr>
            </thead>

            <tbody>
                {(this.state.rechs|| []).map((t, i) => (
                <tr
                    key={i}
                    style={{
                    textAlign: "center",
                    height: "40px",
                    border: "1px solid gray",
                    }}
                >
                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datech ? moment(t.datech).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td
                    style={{
                        color: darck ? "#8f2d56" : "#fff",
                        // textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "16px",
                        border: "1px solid gray",
                    }}
                    >
                    {t.codfrs} {t.raisoc}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.libelle || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.modreg || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.numchq || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datreg ? moment(t.datreg).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.monreg ? Number(t.monreg).toFixed(3) : "--"}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>

<Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.state.rechs
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>
         
           </> ):this.state.showrechbydate ?(   
              <>
               <table
            style={{
                textAlign: "center",
                borderStyle: "10px",
                width: "100%",
                marginTop: "25px",
            }}
            >
            <thead
                style={{
                textAlign: "center",
                paddingTop: "10px",
                paddingBottom: "30px",
                }}
            >
                <tr
                style={{
                    borderBottom: "1px solid grey",
                    border: "1px solid grey",
                    height: "50px",
                }}
                >
                <th style={{ width: "15%" }}>{translate("Date Echeance")}</th>
                <th style={{ width: "25%", border: "1px solid gray" }}>
                    {translate("Fournisseurs")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("Regelement")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("M.Reg")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("N° Pièce")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Date Reg")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Montant")}
                </th>
                </tr>
            </thead>

            <tbody>
                {(this.state.rechdats|| []).map((t, i) => (
                <tr
                    key={i}
                    style={{
                    textAlign: "center",
                    height: "40px",
                    border: "1px solid gray",
                    }}
                >
                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datech ? moment(t.datech).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td
                    style={{
                        color: darck ? "#8f2d56" : "#fff",
                        // textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "16px",
                        border: "1px solid gray",
                    }}
                    >
                    {t.codfrs} {t.raisoc}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.libelle || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.modreg || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.numchq || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datreg ? moment(t.datreg).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.monreg ? Number(t.monreg).toFixed(3) : "--"}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>

<Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.state.rechdats
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>
           </> ):(  
            <>
                    <table
            style={{
                textAlign: "center",
                borderStyle: "10px",
                width: "100%",
                marginTop: "25px",
            }}
            >
            <thead
                style={{
                textAlign: "center",
                paddingTop: "10px",
                paddingBottom: "30px",
                }}
            >
                <tr
                style={{
                    borderBottom: "1px solid grey",
                    border: "1px solid grey",
                    height: "50px",
                }}
                >
                <th style={{ width: "15%" }}>{translate("Date Echeance")}</th>
                <th style={{ width: "25%", border: "1px solid gray" }}>
                    {translate("Fournisseurs")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("Regelement")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("M.Reg")}
                </th>
                <th style={{ width: "15%", border: "1px solid gray" }}>
                    {translate("N° Pièce")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Date Reg")}
                </th>
                <th style={{ width: "10%", border: "1px solid gray" }}>
                    {translate("Montant")}
                </th>
                </tr>
            </thead>

            <tbody>
                {(this.props.AllEchFRS?.AllEchFRS || []).map((t, i) => (
                <tr
                    key={i}
                    style={{
                    textAlign: "center",
                    height: "40px",
                    border: "1px solid gray",
                    }}
                >
                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datech ? moment(t.datech).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td
                    style={{
                        color: darck ? "#8f2d56" : "#fff",
                        // textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "16px",
                        border: "1px solid gray",
                    }}
                    >
                    {t.codfrs} {t.raisoc}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.libelle || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.modreg || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.numchq || "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.datreg ? moment(t.datreg).format("DD/MM/YYYY") : "--"}
                    </td>

                    <td style={{ color: darck ? "black" : "#fff", border: "1px solid gray" }}>
                    {t.monreg ? Number(t.monreg).toFixed(3) : "--"}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>

<Row style={{ marginTop: "10px" }}>
              <Col style={{ textAlign: "center" }} sm={12}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: darck ? "#020F75" : "#fff",
                  }}
                >
                  Total Général Montant :
                  {" "}
                  {this.props.AllEchFRS.AllEchFRS
                    .reduce((s, a) => s + Number(a.monreg || 0), 0)
                    .toFixed(3)}
                </Typography>
              </Col>
            </Row>
           
           </>
           )}



        
       
      
              
               
           
           
               
              </div>
            
          
            
   </div>
   </div>

  {/* /////////////////////////////////////////////////////////// debut print etat ////////////////////////////////////////////////////////////// */}
                      
          
       
        
 
   
        </main>
   
      </div>
    );
  }
}



const mapDispatchToProps = (dispatch) => ({
  getArticleList: (a, b, c, d, e) => {
    dispatch(getArticleList(a, b, c, d, e));
  },
  getArticleHeader: () => {
    dispatch(getArticleHeader());
  },



SelectAllEcheanceFRS :( a, b, c, d, e) => dispatch(SelectAllEcheanceFRS ( a, b, c, d, e)),


});


const mapStateToProps = (state) => {
  return {
   
    Auth: state.Auth,

   // fiches: state.fiches,
    AllReleverClient:state.AllReleverClient,
    AllEchFRS:state.AllEchFRS,
    ConfigDossier: state.ConfigDossier,
    darck: state.darck.darck,
    
    InfoEntreprise: state.InfoDossier,
    Auth: state.Auth,
  };
};
const ConnectedReleveClient = connect(
  mapStateToProps,
  mapDispatchToProps
)(Echeancefrs);

export default ConnectedReleveClient;

// les fonctions utilisées pour le trie des colonnes

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "datefac",
    numeric: false,
    disablePadding: true,
    label: "Date Echéance",
  },
 
  {
    id: "Libelle",
    numeric: true,
    disablePadding: false,
    label: "Client",
  },

  { id: "SIT", numeric: false, disablePadding: false, label: "Reglement" },
  
  {
    id: "MR",
    numeric: true,
    disablePadding: false,
    label: "M.Reg",
  },
  { id: "chqeff", numeric: true,
   disablePadding: false,
    label: "N° Pièce" },
 
  {
    id: "Debit",
    numeric: true,
    disablePadding: false,
    label: "Date Reg",
  
  },
  {
    id: "crédit",
    numeric: true,
    disablePadding: false,
    label: "Montant",
  },

 
];


function EnhancedTableHead(props) {
  const {
    classes,

    order,
    orderBy,

    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "" : ""}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}




const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.grey[300],
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip);
